/**
 * Expand/collapse toggle for the autodoc product description card.
 * Plain button + JS instead of <details>/<summary>, since nesting a
 * -webkit-line-clamp'd block directly inside <summary> renders the
 * browser's native disclosure marker in the wrong place (it can end up
 * floating mid-paragraph instead of at the start of the summary).
 */
document.querySelectorAll('[data-collapsible]').forEach((wrapper) => {
  const toggle = wrapper.querySelector('[data-collapsible-toggle]');
  const preview = wrapper.querySelector('[data-collapsible-preview]');
  const full = wrapper.querySelector('[data-collapsible-full]');
  const more = wrapper.querySelector('.autodoc-info-card__toggle-more');
  const less = wrapper.querySelector('.autodoc-info-card__toggle-less');
  const icon = toggle ? toggle.querySelector('.svg-wrapper') : null;
  if (!toggle || !preview || !full) return;

  toggle.addEventListener('click', () => {
    const expanded = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
    preview.hidden = !expanded;
    full.hidden = expanded;
    if (more) more.hidden = !expanded;
    if (less) less.hidden = expanded;
    if (icon) icon.style.transform = expanded ? '' : 'rotate(180deg)';
  });
});
